import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { NFTContarct } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import Loader from "../components/Loader";
import Nodata from "../assets/img/no-record-found.png";
import { useNavigate } from "react-router-dom";

import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
  FaFilter
} from "react-icons/fa";

const TradeHistory = () => {
const navigate = useNavigate(); 

  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("NFT Activity");

  // FILTER STATES
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [bonusFilter, setBonusFilter] = useState("");
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  // const targetaddress="0x5FD893dF1A7c03f1F673Aa164632A7282Ddd8989";

  const recordsPerPage = 10;
  const formatBalance = (v) => (v ? parseFloat(v).toFixed(2) : "0.00");

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "All NFTs") {
      navigate("/nft-market-place");
    } else if (tab === "TradeHistory") {
      navigate("/my-nft-history");  
    }
  };

  // INIT WEB3
  useEffect(() => {
    let provider = null;
    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;
    if (provider) setWeb3(new Web3(provider));
  }, [client]);

  // BONUS / ACTIVITY NAME
  const getBonusName = (type) => {
    switch (Number(type)) {
      case 10:
        return "NFT Bought";
      case 11:
        return "NFT Sold";
      case 12:
        return "NFT Burned";
      case 13:
        return "NFT Listed";
      default:
        return "Unknown";
    }
  };

    const getStatusBgColor = (bonusName) => {
      return bonusName === "NFT Sold"
        ? "rgba(199, 22, 22, 1)"
        : bonusName === "NFT Bought"
        ? "#888"
        : bonusName === "NFT Burned"
        ? "#d9534f"
        : bonusName === "NFT Listed"
        ? "#32a71bff"
        : "#444";
    };

  // FETCH DATA
  useEffect(() => {
    if (isConnected && address && web3) fetchAllBonuses();
  }, [address, isConnected, web3]);

  const fetchAllBonuses = async () => {
    setLoading(true);
    try {
      const contract = new web3.eth.Contract(
        NFTABI,
        NFTContarct
      );

      const res = await contract.methods.reward_details(address).call();

      const ts = res._reward_timestamp || [];
      const amt = res._reward_credited || [];
      const type = res._reward_type || [];
      const from = res._reward_from || [];
      const tokenId = res.tokenId || [];

    //   const formatted = type
    //     .map((t, i) => {
    //       const rawDate = new Date(Number(ts[i]) * 1000);
    //       return {
    //         bonus_name: getBonusName(t),
    //         type: Number(t),
    //         from: from[i],
    //         tokenId: Number(tokenId[i]),
    //         amount: Web3.utils.fromWei(amt[i].toString(), "ether"),
    //         timestamp: rawDate.toLocaleString(),
    //         dateRaw: rawDate
    //       };
    //     })
    //     .reverse();
    const allowedTypes = [10, 11, 12, 13];

      const formatted = type
        .map((t, i) => {
          const rawDate = new Date(Number(ts[i]) * 1000);
          return {
            bonus_name: getBonusName(t),
            type: Number(t),
            from: from[i],
            // tokenId: Number(tokenId[i]),
            tokenId: tokenId[i] ? tokenId[i].toString() : "",
            amount: Web3.utils.fromWei(amt[i].toString(), "ether"),
            timestamp: rawDate.toLocaleString(),
            dateRaw: rawDate
          };
        })
        // 🔥 ONLY 10, 11, 12, 13 WILL SHOW
        .filter((item) => allowedTypes.includes(item.type))
        .reverse();
      setBonusList(formatted);
    } catch (e) {
      console.error("Fetch error", e);
    }
    setLoading(false);
  };

  // FILTER LOGIC
  const filteredRecords = bonusList.filter((item) => {
    const search = searchValue.toLowerCase();

    const dateValid =
      (!fromDate || item.dateRaw >= new Date(fromDate)) &&
      (!toDate || item.dateRaw <= new Date(toDate));

    const bonusValid =
      bonusFilter === "" ||
      item.bonus_name.toLowerCase() === bonusFilter.toLowerCase();

      const isNumericSearch = searchValue !== "" && !isNaN(searchValue);

        const searchValid =
       searchValue === "" ||
       (isNumericSearch
         ? item.tokenId && item.tokenId.includes(searchValue)
         : item.from.toLowerCase().includes(search) ||
           item.bonus_name.toLowerCase().includes(search) ||
           item.amount.toString().includes(search) ||
           item.timestamp.toLowerCase().includes(search));
     
         return dateValid && bonusValid && searchValid;
       });

  // PAGINATION
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredRecords.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  const [copiedIndex, setCopiedIndex] = useState(null);
  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1200);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
    setBonusFilter("");
  };

  if (loading) return <Loader />;

  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> NFT </span>
          <span className="fw-lighter"> Activity Log</span>
        </div>
      </h4>

          <div class="filter-left">
        {["All NFTs", "NFT Activity", "TradeHistory"].map((tab) => (
          <a
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        ))}
      </div>

    <h4 className="mb-3 mobilefiltername">
  <button
    className="btn btn-light btn-sm"
    onClick={() => setMobileFilterOpen(true)}
  >
    <FaFilter /> Filter
  </button>
</h4>


      <div className="card paddingfilter">
        <div className="card-body">

          {/* MOBILE FILTER */}
          {mobileFilterOpen && (
            <div className="overlay-bg" onClick={() => setMobileFilterOpen(false)} />
          )}

          <div className={`bottom-filter-panel ${mobileFilterOpen ? "show" : ""}`}>
            <div className="close-filter" onClick={() => setMobileFilterOpen(false)}>✕</div>

            <div className="row">

              <div className="col-md-3 mb-3">
                <label className="form-label">Activity Type</label>
                <select
                  className="form-control"
                  value={bonusFilter}
                  onChange={(e) => setBonusFilter(e.target.value)}
                >
                  <option value="">All Activity</option>
                  <option value="NFT Bought">NFT Bought</option>
                  <option value="NFT Sold">NFT Sold</option>
                  <option value="NFT Listed">NFT Listed</option>
                  <option value="NFT Burned">NFT Burned</option>
                </select>
              </div>

              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">From Date</label> <div className="input-icon">
                <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                 <i className="fa-solid fa-calendar iconposition"></i>
              </div>
          </div>

              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">To Date</label> <div className="input-icon">
                <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                 <i className="fa-solid fa-calendar iconposition"></i>
              </div>
            </div>


              <div className="col-md-3 mb-3">
                <label className="form-label">Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Wallet / Token ID"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <div className="col-md-2 mb-3 d-flex align-items-end gap-2">
                <button className="btn btn-success" onClick={() => setMobileFilterOpen(false)}>Apply</button>
                <button className="btn btn-danger" onClick={resetFilters}>Reset</button>
              </div>
            </div>
          </div>

          {/* RECORDS */}
          <div className="row">
            {currentRecords.length > 0 ? (
              currentRecords.map((item, index) => {
                const masked =
                  item.from.slice(0, 4) + "****" + item.from.slice(-4);

                return (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="ref-card">
                      <div className="ref-card-body">
                         <div className="ref-row">

                        <span className="ref-label">
                            <FaHashtag /> S.No
                          </span>
                          <span className="ref-value">
                            {indexOfFirst + index + 1}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label"><FaHashtag /> Token</span>
                          <span className="ref-value">#{item.tokenId}</span>
                        </div>

                        {/* <div className="ref-row">
                          <span className="ref-label"><FaBoxOpen /> Activity</span>
                          <span className="ref-value">{item.bonus_name}</span>
                        </div> */}

                        <div className="ref-row">
                        <span className="ref-label"><FaBoxOpen /> Status</span>
                        <span
                          className="badge"
                          style={{
                            background: getStatusBgColor(item.bonus_name),
                            color: "#fff",
                            padding: "5px 10px",
                            borderRadius: "6px",
                            fontSize: "12px"
                          }}
                        >
                           {item.bonus_name}
                        </span>
                      </div>

                        <div className="ref-row">
                          <span className="ref-label"><FaWallet /> Wallet</span>
                          <div className="ref-copy-box">
                            <span className="ref-value">{masked}</span>
                            <button className="copy-btn" onClick={() => handleCopy(item.from, index)}>
                              {copiedIndex === index ? <FaCheck /> : <FaCopy />}
                            </button>
                          </div>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label"><FaMoneyBillWave /> Amount</span>
                          <span className="ref-badge">{formatBalance(item.amount)} USDT</span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label"><FaClock /> Time</span>
                          <span className="ref-date">{item.timestamp}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">
                <img src={Nodata} alt="" />
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-div">
              <ul className="pagination">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default TradeHistory;
